import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { EventCard } from "@/components/Cards";

export default function Events() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data)); }, []);
  return (
    <div>
      <Seo title="Events Calendar" description="Discover upcoming events in RiNo — First Fridays, gallery openings, mural festivals, night markets, and live music in Denver's River North Art District." />
      <PageHeader overline="What's On" title="RiNo Events Calendar" subtitle="From First Fridays to mural festivals and night markets — everything happening across the River North Art District." />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 gap-5" data-testid="events-list">
          {events.map((e, i) => <EventCard key={e.id} e={e} index={i} />)}
        </div>
      </div>
    </div>
  );
}
